import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/loader.png'


const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-0 flex items-center justify-center bg-transparent"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomLogoLoader',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "relative flex items-center justify-center" }, [
              _createElementVNode("div", { class: "absolute w-24 h-24 rounded-full bg-gradient-to-br from-pink-500/30 via-purple-500/30 to-indigo-500/30 blur-3xl animate-pulse-slow" }),
              _createElementVNode("div", { class: "relative animate-drift" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Loading",
                  class: "w-24 h-auto animate-drift opacity-80"
                }),
                _createElementVNode("div", { class: "absolute inset-0 overflow-hidden rounded-full pointer-events-none" }, [
                  _createElementVNode("div", { class: "absolute -left-1/2 top-0 h-full w-1/2 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-20deg] animate-sweep" })
                ])
              ])
            ], -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})